import { State } from '../state';

export const CustomerSelectors = {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    customer: (state: State) => state.Customer,
};
